import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

export const StatCard = ({ title, value, change, changeType, icon: Icon, color = 'blue' }) => {
  const colorClasses = {
    blue: 'bg-blue-50 text-blue-600',
    emerald: 'bg-emerald-50 text-emerald-600',
    amber: 'bg-amber-50 text-amber-600',
    purple: 'bg-purple-50 text-purple-600'
  };

  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6 hover:shadow-md transition-shadow" data-testid={`stat-card-${title.toLowerCase().replace(/\s+/g, '-')}`}>
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-slate-600 text-sm font-primary font-medium mb-1">{title}</p>
          <p className="text-slate-900 text-3xl font-secondary font-bold tabular-nums mb-2">{value}</p>
          {change && (
            <div className="flex items-center gap-1">
              {changeType === 'increase' && <TrendingUp size={14} className="text-emerald-600" />}
              {changeType === 'decrease' && <TrendingDown size={14} className="text-red-600" />}
              {changeType === 'neutral' && <Minus size={14} className="text-slate-400" />}
              <span className={`text-xs font-medium ${
                changeType === 'increase' ? 'text-emerald-600' : 
                changeType === 'decrease' ? 'text-red-600' : 'text-slate-600'
              }`}>
                {change}
              </span>
            </div>
          )}
        </div>
        {Icon && (
          <div className={`${colorClasses[color]} rounded-lg p-3`}>
            <Icon size={24} strokeWidth={1.5} />
          </div>
        )}
      </div>
    </div>
  );
};
